import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'

import storeHelper from '@/store/helper'
import FileDownload from 'js-file-download'
import moment from 'moment'
export class ReportService extends BaseService {

  static async getListReportByAgent(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.agent.report-agent-bank.report-by-agent'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getListReportByStaff(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.agent.report-agent-bank.report-by-invite-code'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getDetailReportVA(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.agent.report-agent-bank.report-detail-va'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getListDeviceReportBank(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.agent.report-agent-bank.report-detail-device'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async exportReportAgent(params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.report-agent-bank.export.report-by-agent'), params, {
        responseType: 'blob'
      })
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(response.data, 'Export_Report_Agent' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx')
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async exportReportStaff(params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.report-agent-bank.export.report-by-invite-code'), params, {
        responseType: 'blob'
      })
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(response.data, 'Export_Report_Staff' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx')
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async exportReportVa(params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.report-agent-bank.export.report-detail-va'), params, {
        responseType: 'blob'
      })
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(response.data, 'Export_Report_VA' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx')
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async exportReportDevice(params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.report-agent-bank.export.report-detail-device'), params, {
        responseType: 'blob'
      })
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(response.data, 'Export_Report_Device' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx')
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

}
